const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_oEHErTRrK",
    "aws_user_pools_web_client_id": "2bbah6l2g9na3vb94o2l3je9rs"
}

export default awsmobile;